import { Directive, ElementRef, Input, Output, OnChanges, EventEmitter } from '@angular/core';


@Directive({
  selector: '[contenteditableModel]',
  host: {
    '(input)': 'onInput()'
  }
})
export class ContenteditableModelDirective implements OnChanges {
  @Input('contenteditableModel') model: any;
  @Output('contenteditableModelChange') update = new EventEmitter();
  /**Store value to check if data has been updated since last change*/
  private lastViewModel: any;


  constructor(private elRef: ElementRef) {
  }
  /**
   * Angular change event
   * @param changes change details
   */
  ngOnChanges(changes) {
    if (changes['model'] && changes['model'].currentValue !== this.lastViewModel) {
      this.lastViewModel = this.model;
      this.refreshView();
    }
  }
  /**Input triggered event */
  onInput() {
    const value = this.elRef.nativeElement.innerText;
    this.lastViewModel = value;
    this.update.emit(value);
  }
  /**Update the view with the new value */
  private refreshView() {
    this.elRef.nativeElement.innerText = this.model;
  }
}
